import axios from 'axios';

// Environment variables
const API_VERSION = process.env.REACT_APP_API_VERSION || 'v1';
const API_PREFIX = process.env.REACT_APP_API_PREFIX || '/api';

const endpoints = {
    auth: `${API_PREFIX}/${API_VERSION}/users/me`,
    auth_login: `${API_PREFIX}/${API_VERSION}/auth/login`, // POST
    roles: `${API_PREFIX}/${API_VERSION}/roles`,
    users_edit: `${API_PREFIX}/${API_VERSION}/users/{id}`, // PUT
    users_delete: `${API_PREFIX}/${API_VERSION}/users/{id}`, // DELETE

    feeds: `${API_PREFIX}/${API_VERSION}/feeds`,
    feeds_add: `${API_PREFIX}/${API_VERSION}/feeds`, // POST
    feeds_edit: `${API_PREFIX}/${API_VERSION}/feeds/{id}`, // PUT
    feeds_delete: `${API_PREFIX}/${API_VERSION}/feeds/{id}`, // DELETE
    feeds_ext: '/api/v1/feeds-ext',
    feeds_ext_one: '/api/v1/feeds-ext/{id}',
    feeds_ext_add: '/api/v1/feeds-ext', // POST
    feeds_ext_edit: '/api/v1/feeds-ext/{id}', // PUT
    feeds_ext_delete: '/api/v1/feeds-ext/{id}', // DELETE
    feeds_ext_status: '/api/v1/feeds-ext-status/{id}', // PUT
    feeds_ext_rss_test: '/api/v1/feeds-ext-rss-test', // POST
    feedcontents_ext_note: '/api/v1/feedcontents-ext-note/{id}', // PUT
    feedcontents: '/api/v1/feedcontents/{id}',
    feedcontents_data: '/api/v1/feedcontents-data/{id}',
    feedcontents_refresh_data: '/api/v1/feedcontents-refresh-data/{id}',
    feedcontents_read: '/api/v1/feedcontents-read',
    feedcontents_unread: '/api/v1/feedcontents-unread',
    feedcontents_profile_match: '/api/v1/feedcontents/{id}/profile-match',
    feedcontents_claim_owner: '/api/v1/feedcontents/{id}/claim-owner', // POST

    search: '/api/v1/search',

    users: '/api/v1/users',

    tags_assigned: '/api/v1/reports/tags/assigned',
    finders_progress: '/api/v1/reports/finders-progress/{id}',
    finders_analyze: '/api/v1/reports/finders-analyze/{id}',
    feeds_load: '/api/v1/reports/feeds/load',
    ai_reason: '/api/v1/reports/ai/reason/{id}',

    run_job_feed: '/api/v1/jobs/load-rss/{id}',
    run_job_finder: '/api/v1/jobs/finder/{id}',
    testmode: '/api/v1/jobs/test-mode-status',
    settings: '/api/v1/jobs/settings/{name}',

    tags: '/api/v1/tags',
    tags_add: '/api/v1/tags', // POST
    tags_edit: '/api/v1/tags/{id}', // PUT
    tags_delete: '/api/v1/tags/{id}', // DELETE

    tags_content_add: '/api/v1/tags/{id}/feedcontent/{contentId}',
    tags_content_delete: '/api/v1/tags/{id}/feedcontent/{contentId}',
    
    prompts: '/api/v1/coverletter-prompts',
    prompts_add: '/api/v1/coverletter-prompts', // POST
    prompts_edit: '/api/v1/coverletter-prompts/{id}', // PUT
    prompts_delete: '/api/v1/coverletter-prompts/{id}', // DELETE

    coverletters: '/api/v1/coverletters/{feedContentId}',
    coverletters_add: '/api/v1/coverletters/{feedContentId}/{version}',
    coverletters_delete: '/api/v1/coverletters/{feedContentId}/{version}', // DELETE
    
    portfolio: '/api/v1/portfolio',
    portfolio_add: '/api/v1/portfolio', // POST
    portfolio_edit: '/api/v1/portfolio/{id}', // PUT
    portfolio_delete: '/api/v1/portfolio/{id}', // DELETE
    portfolio_import: '/api/v1/portfolio-import', // POST
    portfolio_ai_rate: '/api/v1/portfolio-ai-rate',
    
    autoreply: '/api/v1/autoreply',  
    autoreply_add: '/api/v1/autoreply', // POST
    autoreply_delete: '/api/v1/autoreply/{id}', // DELETE
    autoreply_test: '/api/v1/autoreply-test', // POST
    autoreply_gmail_login: '/api/v1/autoreply/gmail/login', // GET
    autoreply_gmail_logout: '/api/v1/autoreply/gmail/logout', // GET
    autoreply_gmail_check: '/api/v1/autoreply/gmail/check', // GET
    
    team: '/api/v1/team',
    team_member: '/api/v1/team/{id}',
    team_sync: '/api/v1/team/sync', // POST
    team_member_sync: '/api/v1/team/{id}/sync', // POST
    team_member_visibility: '/api/v1/team/{id}/visibility', // PUT

    integrations_upwork: '/api/v1/integrations/upwork',
    integrations_upwork_login: '/api/v1/integrations/upwork/login', // GET
    integrations_upwork_refresh: '/api/v1/integrations/upwork/refresh', // POST
    integrations_upwork_check: '/api/v1/integrations/upwork/check', // POST
    integrations_upwork_service_account: '/api/v1/integrations/upwork/service-account', // PUT
    integrations_upwork_disconnect: '/api/v1/integrations/upwork/{id}', // DELETE

    pipedrive_deals_fields: '/api/v1/pipedrive/deals/fields',
    pipedrive_users: '/api/v1/pipedrive/users',
    pipedrive_leads_labels: '/api/v1/pipedrive/leads/labels',
    pipedrive_persons_labels: '/api/v1/pipedrive/persons/labels',
    
    notifications: '/api/v1/notifications',
}

export function getBackendUrl(endpoint = '', token = '') {
    if (token) {
        token = '?token=' + token
    }

    let url = process.env.REACT_APP_BACKEND_URL ?? 'http://localhost:3000'
    return url + endpoint + token
}

export async function apiRequest(method, endpoint, data, authRedirect = true) {
    let url = getBackendUrl(endpoint)
    
    const a = url.split('/')
    for (let i in a) {
        if (a[i].indexOf('{') === 0) {
            const p = a[i].substr(1, a[i].length - 2)
            if (data[p] !== undefined) {
                url = url.replace('{' + p + '}', data[p])
                delete data[p]
            }
        }
    }
    
    let config = {
        method: method,
        url: url,
        withCredentials: true,
        validateStatus: function (status) {
            return status < 300 || status === 403;
        }
    }
    
    if (method == 'get') {
        config.params = data
        if (data.cancelToken) {
            config.cancelToken = data.cancelToken
        }
    } else {
        if (data.token) {
            config.url = config.url + '?token=' + data.token
            delete data.token
        }
        config.data = data
    }
    
    const result = await axios.request(config)
    
    if (result.data.status == 'forbidden' && result.data.redirect) {
        if (authRedirect === true) {
            window.location.href = '/login'
        }
        return result
    }
    
    return result
}

export default endpoints;